import React from "react";

export default function Titlee() {
  return (
    <div className="">
      <h1 className="text-2xl text-white font-bold" style={{
        textShadow: '1px 1px 10px white'
      }}>Bienvenido al Menu de comida</h1>
    </div>
  );
}
